import { tv } from 'tailwind-variants'

export const referralVariants = tv({
  slots: {
    header: 'pb-mili flex items-center gap-mili text-secondary-medium',
    body: 'flex flex-col text-mili italic py-mili gap-mili text-secondary-medium cursor-pointer hover:text-primary-medium'
  }
})
